import { Link } from 'react-router-dom'
import { MobileTitle } from '../../components/Title'
// import { Tweet, Timeline } from 'react-twitter-widgets'
export const Contest = () => {
    return (
        <>
            <div className='md:pt-0 md:mt-20'>
                <div className='py-12 w-full text-center mx-auto'>
                    <span className='relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>Contest</h1>{' '}
                    </span>
                </div>
                <div className='mt-12 md:mt-0 mx-auto relative flex justify-center'>
                    {' '}
                    <span className='relative inline-block'>
                        {' '}
                        <div>
                            <img
                                className='max-w-[300px] mx-auto'
                                src={`${process.env.PUBLIC_URL}/images/contest/header-contest.webp`}
                                alt='contest'
                            />{' '}
                        </div>{' '}
                    </span>
                </div>{' '}
            </div>
            <div className='px-4 max-w-[1000px] mx-auto my-28'>
                <div className='flex flex-col md:flex-row justify-center mt-8 gap-8 mx-auto'>
                    <Link to={`putty-contest`}>
                        {' '}
                        <div className='border-2 border-white'>
                            <img
                                className='text-center hover:brightness-110 duration-300 cursor-pointer'
                                src={`${process.env.PUBLIC_URL}/images/contest/putty-contest-banner.webp`}
                                alt='putty contest'
                            />{' '}
                        </div>{' '}
                    </Link>{' '}
                    <Link to={`retweet-contest`}>
                        {' '}
                        <div className='border-2 border-white'>
                            {' '}
                            <img
                                className='text-center hover:brightness-150 duration-300 cursor-pointer'
                                src={`${process.env.PUBLIC_URL}/images/contest/retweet-contest-banner.webp`}
                                alt='retweet contest'
                            />{' '}
                        </div>
                    </Link>{' '}
                </div>{' '}
            </div>
        </>
    )
}
